<template>
    <div class="doubleLine"></div>
</template>

<script>
export default {
    name: '',
    props: {
        pondsid: Number
    },
    data() {
        return {
            myChart: null,
            xData:[],
            yData:[]
        }
    },
    methods: {
        setData(){
            this.request.get("/api/Echart/getpage2",{
                params: {
                    pondsid:this.pondsid,
                    param: "Tur",
                    number:10
                }
            }).then(res => {
                if(res.code == 200){
                    let data = res.data;
                    this.xData = data.map(item =>{ // 假设 item.time 是 "2024-03-30T10:03:47"  
                        const timeParts = item.time.split(' '); // 将字符串分割为日期和时间两部分  
                        const datePart = timeParts[0]; // 获取日期部分，即 "2024-03-30"  
                        const timePart = timeParts[1]; // 获取时间部分，即 "10:03:47"  
                    
                        // 从日期部分提取月和日  
                        const month = datePart.substring(5, 7); // "03"  
                        const day = datePart.substring(8, 10); // "30"  
                    
                        // 从时间部分提取时和分  
                        const hour = timePart.substring(0, 2); // "10"  
                        const minute = timePart.substring(3, 5); // "03"  
                    
                        // 拼接成 "月 日 时 分" 的格式  
                        return `${month}-${day} ${hour}:${minute}`; });
                    this.yData = data.map(item => item.tur)    
                }
                this.setChart()
            })
        },
        setChart() {
            const allNull = this.yData.every(item => item === null);
            let option = {
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    left: "11%",
                    top: "10%",
                    itemWidth: 7,
                    itemHeight: 7,
                    textStyle: {
                        color: '#fff',
                        fontSize: 10
                    }
                },
                graphic: allNull ? [{
            type: 'text',
            left: 'center', // 根据需要调整位置
            top: 'center',
            style: {
                text: '暂无此参数数据',
                textAlign: 'center',
                fill: '#ccc', // 文本颜色
                fontSize: 25
            }
        }] : [],
                grid: {
                    top: '12%',
                    left: '10%',
                    right: '10%',
                    bottom: '10%',
                    containLabel: false
                },

                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        symbol: ['none', 'arrow'],
                        symbolSize: [6, 6],
                        symbolOffset: [0, 10],
                        lineStyle: {
                            color: '#122C49'
                        }
                    },
                    axisTick: {show: false},
                    axisLabel: {
                        color: '#fff',
                        fontSize: 9
                    },
                    data: this.xData
                },
                yAxis: [
                    {
                        type: 'value',
                        scale: true,
                        axisLine: {
                            symbol: ['none', 'arrow'],
                            symbolSize: [6, 6],
                            lineStyle: {
                                color: '#122C49'
                            }
                        },
                        axisLabel: {
                            color: '#fff',
                            showMaxLabel: false,
                            fontSize: 9
                        },
                        name: '(JTU)',
                        nameGap: -10,
                        nameTextStyle: {
                            color: '#fff',
                            fontSize: 9,
                            align: 'right',
                            padding: [0, 6, 0, 0]
                        },
                        splitLine: {
                            show: false,
                        },
                    },
                ],
                series: [
                    {
                        name: '浊度',
                        type: 'line',
                        smooth: true,
                        symbol: 'none',
                        lineStyle: {
                            color: '#F39800',
                        },
                        itemStyle: {
                            color: '#F39800'
                        },
                        data: this.yData
                    },
                ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize()
            this.myChart.setOption(option);
        }
    },
    mounted() {
        this.setData()
    },
    watch: {
        pondsid() {
            this.setData()
        
        }
    }
}
</script>

<style lang="less" scoped>
.doubleLine {
    height: 100%;
    width: 100%;
}
</style>
